/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const ArrowLeftTail: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 28 28" size={size} color={color} {...props}>
      <path
        d="M6 13.922L13.234 7l1.55 1.483L10.064 13H21v2H10.064l4.72 4.517L13.234 21 6 14.078 6.081 14 6 13.922z"
        fillRule="evenodd"
      />
    </Icon>
  );
};

export default ArrowLeftTail;

ArrowLeftTail.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
